import {appendQueryString, parseSearch} from "@pg-mono/request";

import {addFailureNotification} from "../../notifications/utils/add_failure_notification";
import {addSuccessNotification} from "../../notifications/utils/add_success_notification";
import {IAppDispatch} from "../../store/store";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AuthActionType} from "../types/AuthActionType";
import {authSucceeded} from "./auth_succeeded_event";

export const afterRedirectOauthLogin = (isAuthenticated: boolean) => async (dispatch: IAppDispatch) => {
    if (window) {
        const query = parseSearch(location.search);

        if (query.oauth_login) {
            const isNewUser = query.new_user === "true";
            dispatch(
                authSucceeded({
                    type: isNewUser ? AuthActionType.REGISTRATION : AuthActionType.LOGIN,
                    userSource: UserSource.NAVIGATION,
                    registrationMethod: "social"
                })
            );

            dispatch(
                isAuthenticated
                    ? addSuccessNotification("Zalogowano do konta")
                    : addFailureNotification("Wystąpił błąd podczas logowania do konta. Spróbuj ponownie później.")
            );

            // Remove query params - we don't need them anymore
            delete query.oauth_login;
            delete query.new_user;

            window.history.replaceState({}, document.title, appendQueryString(location.pathname, query));
        }
    }
};
import {appendQueryString, parseSearch} from "@pg-mono/request";

import {addFailureNotification} from "../../notifications/utils/add_failure_notification";
import {addSuccessNotification} from "../../notifications/utils/add_success_notification";
import {IAppDispatch} from "../../store/store";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AuthActionType} from "../types/AuthActionType";
import {authSucceeded} from "./auth_succeeded_event";

export const afterRedirectOauthLogin = (isAuthenticated: boolean) => async (dispatch: IAppDispatch) => {
    if (window) {
        const query = parseSearch(location.search);

        if (query.oauth_login) {
            const isNewUser = query.new_user === "true";
            dispatch(
                authSucceeded({
                    type: isNewUser ? AuthActionType.REGISTRATION : AuthActionType.LOGIN,
                    userSource: UserSource.NAVIGATION,
                    registrationMethod: "social"
                })
            );

            dispatch(
                isAuthenticated
                    ? addSuccessNotification("Zalogowano do konta")
                    : addFailureNotification("Wystąpił błąd podczas logowania do konta. Spróbuj ponownie później.")
            );

            // Remove query params - we don't need them anymore
            delete query.oauth_login;
            delete query.new_user;

            window.history.replaceState({}, document.title, appendQueryString(location.pathname, query));
        }
    }
};
